import produce from 'immer';
import {
    GET_ADDRESS,
    GET_ADDRESS_SUCCESS,
    GET_ADDRESS_FAILED,
    INIT_ADDRESS_FORM,
    SAVE_FORM_DATA_VALUES,
    HANDLE_VALID_API_RESPONSE,
    HANDLE_INVALID_API_RESPONSE,
} from './constant';

/**
 * Export initalState
 *
 * @export initalState
 */
export const initialState = {
    loading: false,
    error: false,
    addressNotFound: false,
    initAddressForm: false,
    formData: {},
    responseData: {},
};

const glasfaserVfp = (state = initialState, action) =>
    produce(state, draft => {
        switch (action.type) {
            case GET_ADDRESS:
                draft.loading = true;
                break;
            case GET_ADDRESS_FAILED:
                draft.addressNotFound = true;
                draft.initAddressForm = false;
                break;
            case GET_ADDRESS_SUCCESS:
                draft.addressNotFound = false;
                draft.initAddressForm = false;
                break;
            case INIT_ADDRESS_FORM:
                draft.initAddressForm = true;
                draft.error = false;
                draft.formData = false;
                draft.responseData = false;
                break;
            case SAVE_FORM_DATA_VALUES:
                draft.formData = {
                    ...draft.formData,
                    ...action.update,
                };
                break;
            case HANDLE_VALID_API_RESPONSE:
                draft.loading = false;
                draft.responseData = action.responseData;
                break;
            case HANDLE_INVALID_API_RESPONSE:
                draft.loading = false;
                draft.initAddressForm = false;
                draft.error = true;
                break;
        }
    });

export default glasfaserVfp;
